import lineRibbonBg from "assets/svg/line-ribbon-bg.svg";
import {
  DashboardAiInsightsType,
  FilterNamesEnum,
  NavigationPageEnum
} from "pages/project-dashboard/models";
import AIPoweredIcon from "components/svg-icons/ai-powered-icon";
import { MaterialCiqIcon } from "components/svg-icons";
import { Button } from "antd";

function AiInsightCard({
  count,
  label,
  onClickOfView
}: {
  count: number;
  label: string;
  onClickOfView: () => void;
}) {
  return (
    <div className="flex items-center space-x-3 border border-solid border-ciq-golden-purple-400 rounded-lg px-2 py-1 bg-white z-10">
      <div className="py-1.5">
        <div className="w-16 gap-2 px-2 py-0.5 flex items-center border border-solid border-ciq-teal-400 rounded-sm bg-ciq-teal-200 bg-opacity-30">
          <MaterialCiqIcon size={16} />
          <div>{count}</div>
        </div>
      </div>
      <div className="grow">{label}</div>
      <div className="pr-2">
        <Button
          type="link"
          className="p-0 h-fit"
          onClick={onClickOfView}
          data-testid="view-ai-insight-button"
        >
          View
        </Button>
      </div>
    </div>
  );
}

function AiInsightDashboard({
  ai_insightsMaterials,
  goToFiltered
}: {
  ai_insightsMaterials: DashboardAiInsightsType;
  goToFiltered: (
    page: NavigationPageEnum,
    filter: FilterNamesEnum,
    value?: any
  ) => void;
}) {
  const {
    field_measurement_required,
    mockups_required,
    mockups_proof,
    recessed_condition
  } = ai_insightsMaterials;
  return (
    <div className="p-5 bg-ciq-golden-purple-50 rounded relative">
      <div
        className="ai-insight-section-bg"
        style={{
          backgroundImage: `url(${lineRibbonBg})`
        }}
        aria-hidden
      />
      <div className="flex flex-col space-y-4">
        <div className="flex items-center space-x-2">
          <AIPoweredIcon className="fill-ciq-golden-purple-900" size={16} />
          <div className="text-ciq-golden-purple-900 text-base font-semibold">
            AI Insight
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          {field_measurement_required && (
            <AiInsightCard
              count={field_measurement_required}
              label="Materials require field measurement"
              onClickOfView={() => {
                goToFiltered(
                  NavigationPageEnum.MaterialLog,
                  FilterNamesEnum.AIInsightsFieldMeasurementRequired,
                  true
                );
              }}
            />
          )}
          {mockups_required && (
            <AiInsightCard
              count={mockups_required}
              label="Materials require Mockups"
              onClickOfView={() => {
                goToFiltered(
                  NavigationPageEnum.MaterialLog,
                  FilterNamesEnum.AIInsightsMockupsRequired,
                  true
                );
              }}
            />
          )}
          {mockups_proof && (
            <AiInsightCard
              count={mockups_proof}
              label="Material proof of Mockups"
              onClickOfView={() => {
                goToFiltered(
                  NavigationPageEnum.MaterialLog,
                  FilterNamesEnum.AIInsightsMockupsProof,
                  true
                );
              }}
            />
          )}
          {recessed_condition && (
            <AiInsightCard
              count={recessed_condition}
              label="Materials are in recessed conditions"
              onClickOfView={() => {
                goToFiltered(
                  NavigationPageEnum.MaterialLog,
                  FilterNamesEnum.AIInsightsRecessedCondition,
                  true
                );
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AiInsightDashboard;
